import {
  DEFAULT_FRAGMENTS,
  NGSS_FRAGMENTS,
  ISTE_FRAGMENTS,
  CCSS_M_FRAGMENTS,
  ABET_FRAGMENTS,
  TWENTY_FIRST_CS_FRAGMENTS,
  JUNIOR_LESSON_FRAGMENTS,
  SENIOR_LESSON_FRAGMENTS,
  UNDERGRADUAT_LECTURE_FRAGMENTS
} from "./standardsFragments";

export const BUILT_IN_TEMPLATES = [
  {
    id: "default",
    name: "Default Template",
    domain: "Auto",
    sectionsPerLesson: 3,
    readingLevel: "Auto",
    tone: "Auto",
    mediaDensity: "none",
    codeLanguage: "Auto",
    timePerLesson: 60,
    language: "English",
    fragments: DEFAULT_FRAGMENTS,
    builtIn: true
  },
  {
    id: "junior",
    name: "Junior High (12-15)",
    domain: "Auto",
    sectionsPerLesson: 2,
    readingLevel: "grade-8",
    tone: "friendly",
    mediaDensity: "none",
    codeLanguage: "Auto",
    timePerLesson: 45,
    language: "English",
    fragments: JUNIOR_LESSON_FRAGMENTS,
    builtIn: true
  },
  {
    id: "senior",
    name: "Senior High (16-18)",
    domain: "Auto",
    sectionsPerLesson: 3,
    readingLevel: "grade-11",
    tone: "conversational",
    mediaDensity: "none",
    codeLanguage: "Auto",
    timePerLesson: 50,
    language: "English",
    fragments: SENIOR_LESSON_FRAGMENTS,
    builtIn: true
  },
  {
    id: "undergraduate",
    name: "Undergraduate Lecture",
    domain: "Auto",
    sectionsPerLesson: 3,
    readingLevel: "undergrad",
    tone: "professional",
    mediaDensity: "none",
    codeLanguage: "Auto",
    timePerLesson: 60,
    language: "English",
    fragments: UNDERGRADUAT_LECTURE_FRAGMENTS,
    builtIn: true
  },
  {
    id: "ngss",
    name: "NGSS (Science)",
    domain: "STEM",
    sectionsPerLesson: 3,
    readingLevel: "undergrad",
    tone: "professional",
    mediaDensity: "none",
    codeLanguage: "Auto",
    timePerLesson: 60,
    language: "English",
    fragments: NGSS_FRAGMENTS,
    builtIn: true
  },
  {
    id: "ccssm",
    name: "CCSS-Math",
    domain: "STEM",
    sectionsPerLesson: 3,
    readingLevel: "undergrad",
    tone: "professional",
    mediaDensity: "none",
    codeLanguage: "Auto",
    timePerLesson: 60,
    language: "English",
    fragments: CCSS_M_FRAGMENTS,
    builtIn: true
  },
  {
    id: "iste",
    name: "ISTE (Digital Skills)",
    domain: "Skills",
    sectionsPerLesson: 3,
    readingLevel: "undergrad",
    tone: "conversational",
    mediaDensity: "none",
    codeLanguage: "Auto",
    timePerLesson: 60,
    language: "English",
    fragments: ISTE_FRAGMENTS,
    builtIn: true
  },
  {
    id: "abet",
    name: "ABET Engineering",
    domain: "STEM",
    sectionsPerLesson: 4,
    readingLevel: "undergrad",
    tone: "professional",
    mediaDensity: "none",
    codeLanguage: "Auto",
    timePerLesson: 75,
    language: "English",
    fragments: ABET_FRAGMENTS,
    builtIn: true
  },
  {
    id: "21cs",
    name: "21st-Century Skills",
    domain: "Vocational / Trades",
    sectionsPerLesson: 2,
    readingLevel: "undergrad",
    tone: "friendly",
    mediaDensity: "none",
    codeLanguage: "Auto",
    timePerLesson: 45,
    language: "English",
    fragments: TWENTY_FIRST_CS_FRAGMENTS,
    builtIn: true
  }
];
